import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { HEADER_SPACING_PRESETS, NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import { useEmployeeEmployerProfileUrlParams } from 'global/hooks/useEmployeeEmployerProfileUrlParams';
import GroupTabSwitcher from 'components/common/subscriber/GroupTabSwitcher';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import SubscriberTasks from 'components/subscriber/employee-profile/SubscriberTasks';
import { useEmployeeProfilePageStore } from 'store/pages/subscriber/employee-profile/pageStore';
import EmployeeHeaderSubtitle from './EmployeeHeaderSubtitle';

const PageContent: React.FC = observer(() => {
  const { groupId } = useEmployeeEmployerProfileUrlParams();
  const {
    isInitialLoading,
    multiLoginModule,
    subscriberTasksModule,
    isGroupsListLoading,
    setupActiveGroup,
    buildSubscriberTasksModule,
    reLoginIntoActiveGroup,
  } = useEmployeeProfilePageStore();

  useEffect(() => {
    void setupActiveGroup(groupId);
  }, []);

  useEffect(() => {
    if (groupId && !isGroupsListLoading) {
      buildSubscriberTasksModule(groupId);
    }
  }, [groupId, isGroupsListLoading]);

  const moreInfoBlob = multiLoginModule.moreInfoBlobInput
    ? buildGroupContextMoreInfoBlobProps(multiLoginModule.moreInfoBlobInput)
    : undefined;

  // Plain objects so tab click handlers don't read observables outside a reactive context
  const groups = [...multiLoginModule.groupsWhereUserIsEmployee, ...multiLoginModule.groupsWhereUserIsEmployer].map(
    (group) => toJS(group),
  );

  return (
    <NoSidebarPageLayout
      contentWidth="narrow"
      isInitialLoading={isInitialLoading}
      isInfoSectionLoading={isInitialLoading}
      moreInfoBlob={moreInfoBlob}
      pageHeader={{
        title: 'Benefits Dashboard',
        subtitle: <EmployeeHeaderSubtitle />,
        subtitleMaxWidth: '80rem',
        spacing: HEADER_SPACING_PRESETS.withTopSection,
      }}
    >
      <GroupTabSwitcher
        groups={groups}
        activeGroupId={multiLoginModule.activeGroup?.id ?? groupId ?? ''}
        onSelectGroup={(group) => {
          void reLoginIntoActiveGroup(group.id, group.seUserRole);
        }}
      >
        {subscriberTasksModule ? <SubscriberTasks subscriberTasksModule={subscriberTasksModule} /> : null}
      </GroupTabSwitcher>
    </NoSidebarPageLayout>
  );
});

export default PageContent;
